import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  id: "slide-large-icon",
  role: "img",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M5.082 2.25C3.51779 2.25 2.25 3.51779 2.25 5.082V13.918C2.25 15.4822 3.51779 16.75 5.082 16.75H18.918C20.482 16.75 21.75 15.4824 21.75 13.919V5.082C21.75 3.51802 20.4824 2.25 18.919 2.25H5.082ZM3.75 5.082C3.75 4.34621 4.34621 3.75 5.082 3.75H18.919C19.6535 3.75 20.25 4.34598 20.25 5.082V13.919C20.25 14.6536 19.654 15.25 18.918 15.25H5.082C4.34621 15.25 3.75 14.6538 3.75 13.918V5.082Z"
    }, null, -1),
    _createElementVNode("path", { d: "M10.75 20.0027C10.7465 19.3085 11.3098 18.75 11.998 18.75C12.6883 18.75 13.25 19.3078 13.25 20C13.25 20.6902 12.6902 21.25 12 21.25C11.3107 21.25 10.7515 20.6917 10.75 20.0027Z" }, null, -1),
    _createElementVNode("path", { d: "M7.00001 20.0268C6.99752 19.5408 7.39183 19.1499 7.8736 19.1499C8.35679 19.1499 8.75 19.5404 8.75 20.0249C8.75 20.5081 8.35815 20.8999 7.875 20.8999C7.39249 20.8999 7.00104 20.5091 7.00001 20.0268Z" }, null, -1),
    _createElementVNode("path", { d: "M15 20.0268C14.9975 19.5408 15.3918 19.1499 15.8736 19.1499C16.3568 19.1499 16.75 19.5404 16.75 20.0249C16.75 20.5081 16.3582 20.8999 15.875 20.8999C15.3925 20.8999 15.001 20.5091 15 20.0268Z" }, null, -1)
  ])))
}
export default { render: render }